import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=3bf7c19e"
import script from "./Consulta.vue?vue&type=script&lang=ts"
export * from "./Consulta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports